import React, { useMemo } from 'react';
import { JsonLd } from '../../JsonLd';
import { SchemaOrgType } from '../../../seo.constants';
import { CurrentResidenceQuery } from '../../../graphql/graphql';
import { useRealEstateAgentSchema } from '../../../hooks/useRealEstateAgentSchema';

interface ResidencePageSchemaProps {
  residence: CurrentResidenceQuery['residence'];
}

export const ResidencePageSchema: React.FC<ResidencePageSchemaProps> = ({
  residence
}) => {
  if (!residence) return;

  const { address, price, contactEmail, photos, lat, lng } = residence;
  const baseItemJsonLd = useRealEstateAgentSchema(residence, address);
  const { total, currency } = price;

  const itemJsonLd = useMemo(
    () => ({
      ...baseItemJsonLd,
      email: contactEmail,
      priceRange: `${total?.minimum} ${currency} - ${total?.maximum} ${currency}`,
      photo: photos?.map(photo => ({
        '@type': SchemaOrgType.ImageObject,
        contentUrl: photo?.full
      })),
      geo: {
        '@type': SchemaOrgType.GeoCoordinates,
        latitude: lat,
        longitude: lng
      }
    }),
    [contactEmail, total, currency, photos, lat, lng, baseItemJsonLd]
  );

  return <JsonLd data={itemJsonLd} />;
};
